module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/mobile/svg/file_pdf_32-56b47c.svg";